
import axios from "axios";

let apiBaseUrl = null;

const DEFAULT_MASTER_API_PATH = '/api/v1';
const DEFAULT_MASTER_HOST = 'http://localhost:3001';

const getWindow = () => (typeof window !== 'undefined' ? window : undefined);

const resolveClientUrl = () => {
  const envUrl = process.env.REACT_APP_CLIENT_URL;
  if (envUrl && envUrl.trim()) {
    return envUrl.trim();
  }
  const win = getWindow();
  if (win && win.location && win.location.origin) {
    return win.location.origin;
  }
  return DEFAULT_MASTER_HOST;
};

const resolveMasterApiUrl = () => {
  const win = getWindow();
  const envUrl = process.env.REACT_APP_CLIENT_MASTER_API_URL;
  let baseCandidate;

  if (envUrl && envUrl.trim()) {
    baseCandidate = envUrl.trim();
  } else {
    const isLocalHost = (win && win.location && win.location.hostname === 'localhost');
    const fallbackBase = isLocalHost ? DEFAULT_MASTER_HOST : resolveClientUrl();
    baseCandidate = `${fallbackBase.replace(/\/$/, '')}${DEFAULT_MASTER_API_PATH}`;
  }

  try {
    const parsed = new URL(baseCandidate, DEFAULT_MASTER_HOST);
    if (win && win.location && win.location.protocol === 'https:' && parsed.protocol === 'http:') {
      parsed.protocol = 'https:';
    }
    return parsed.toString().replace(/\/$/, '');
  } catch (_) {
    return `${DEFAULT_MASTER_HOST}${DEFAULT_MASTER_API_PATH}`;
  }
};

export async function loadApiConfig() {
  const hostDetails = { ClientUrl: resolveClientUrl() };
  const masterApiUrl = resolveMasterApiUrl();

  try {
    const response = await axios.get(`${masterApiUrl}/getApiUri`, { params: hostDetails });
    if (response.status === 200) {
      const payload = response.data?.data?.[0];
      apiBaseUrl = payload?.APIUrl || null;
      if (!apiBaseUrl) {
        throw new Error('APIUrl missing in response payload');
      }
      return payload;
    }
    throw new Error(`Unexpected response status ${response.status}`);
  } catch (err) {
    console.error('Failed to load API config', err);
    apiBaseUrl = `${DEFAULT_MASTER_HOST}${DEFAULT_MASTER_API_PATH}`;
    return null;
  }
}

export function getApiBaseUrl() {
  if (!apiBaseUrl) {
    console.warn('API base URL not loaded yet. Did you call loadApiConfig()?');
  }
  return apiBaseUrl;
}